import Marquee from "react-fast-marquee";
import { Snowflake } from "lucide-react";
import { useI18n } from "../i18n/LanguageContext";

export const EditorialMarquee = () => {
  const { t } = useI18n();
  return (
    <section data-testid="editorial-marquee" className="py-10 border-y border-pine/10 bg-cream overflow-hidden">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {t("marquee").map((item) => (
          <span key={item} className="flex items-center">
            <span className="font-serif italic text-2xl md:text-3xl text-pine/70 px-8 whitespace-nowrap">{item}</span>
            <Snowflake aria-hidden className="w-4 h-4 text-wood shrink-0" />
          </span>
        ))}
      </Marquee>
    </section>
  );
};
